import { Box, Surface, Text } from '@/ui/primitives';
import {
  EMPTY_STATE_ACTION_SX,
  EMPTY_STATE_BODY_SX,
  EMPTY_STATE_CENTER_SX,
  EMPTY_STATE_CONTENT_SX,
  EMPTY_STATE_ICON_SX,
  EMPTY_STATE_TITLE_SX,
} from './statePanelStyles';
import type { ReactElement, ReactNode } from 'react';

type EmptyStateProps = {
  icon?: ReactNode;
  title: string;
  body?: string;
  action?: ReactNode;
  surface?: boolean;
};

export const EmptyState = ({
  icon,
  title,
  body,
  action,
  surface = true,
}: EmptyStateProps): ReactElement => {
  const content = (
    <Box sx={EMPTY_STATE_CONTENT_SX}>
      {icon ? <Box sx={EMPTY_STATE_ICON_SX}>{icon}</Box> : null}
      <Text role="sectionTitle" sx={EMPTY_STATE_TITLE_SX}>
        {title}
      </Text>
      {body ? (
        <Text role="bodyMuted" sx={EMPTY_STATE_BODY_SX}>
          {body}
        </Text>
      ) : null}
      {action ? <Box sx={EMPTY_STATE_ACTION_SX}>{action}</Box> : null}
    </Box>
  );

  if (!surface) {
    return <Box sx={EMPTY_STATE_CENTER_SX}>{content}</Box>;
  }

  return (
    <Surface padding="xl" border={false} sx={EMPTY_STATE_CENTER_SX}>
      {content}
    </Surface>
  );
};
